import {
  CheckImageIsFile,
  CheckDataIfExit,
  CheckTypeFile,
} from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";
import { toast } from "react-toastify";

export const GetSubServicesMediaGallery =
  ({ callback }) =>
    async (dispatch, getState) => {
      try {
        let link = UrlApi.media_gallery.get_sub_services;
        const response = await GetFunction({
          data: {},
          Route: link,
          showalert: false,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
          usersRoute: true,
        });
        callback(response);
      } catch (err) {
        callback(false);
      }
    };

export const DeleteEventsMediaGallery =
  ({ mediaTypeId, callback }) =>
    async (dispatch, getState) => {
      try {
        let link = UrlApi.media_gallery.delete;
        const response = await GetFunction({
          data: {},
          Route: link + `/${mediaTypeId}`,
          showalert: false,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
          usersRoute: true,
        });
        callback(response);
      } catch (err) {
        callback(false);
      }
    };

export const ManageSubServicesMediaGallery =
  ({ callback, values, editMode = false }) =>
    async (dispatch, getState) => {
      try {
        dispatch(setLoading(true));
        const paramID = editMode ? values?.id : "";
        if (editMode && !values?.id) {
          dispatch(setLoading(false));
          return toast.error("Missing record ID");
        }
        if (!editMode && !values?.sub_service_id) {
          dispatch(setLoading(false));
          return toast.error("Please select a Sub Service");
        }
        var bodyFormData = new FormData();
        if (!editMode) {
          bodyFormData.append("id", values?.sub_service_id);
          const mediaName = values?.media
            ? values?.media.name ||
            (typeof values?.media === "string" ? values?.media : "")
            : "";
          const isVideo = mediaName
            ? CheckTypeFile({ name: mediaName }) === "video"
            : false;
          bodyFormData.append(
            "video_time",
            isVideo ? values?.video_time || "" : "-"
          );
          if (CheckDataIfExit(values?.title)) {
            bodyFormData.append("title", values?.title?.trim());
          }
          if (CheckDataIfExit(values?.description)) {
            bodyFormData.append("description", values?.description?.trim());
          }
          bodyFormData.append("type", "sub_service");
          if (!values.media) {
            dispatch(setLoading(false));
            return toast.error("Please select a media");
          }
        }
        if (values?.order_number != null && values?.order_number !== "") {
          bodyFormData.append(
            "order_number",
            typeof values?.order_number === "number"
              ? values.order_number
              : String(values?.order_number).trim()
          );
        }
        if (
          values?.media &&
          values?.media != null &&
          values?.media !== undefined &&
          CheckImageIsFile({ data: values?.media, IsBoolean: true })
        ) {
          bodyFormData.append("media", values?.media);
        } else if (editMode && !values?.media) {
          bodyFormData.append("media", "");
        } else if (!editMode) {
          bodyFormData.append("media", values?.media);
        }
        if (!editMode) {
          if (
            values?.cover &&
            values?.cover != null &&
            values?.cover !== undefined &&
            CheckImageIsFile({ data: values?.cover, IsBoolean: true })
          ) {
            bodyFormData.append("cover", values?.cover);
          } else if (editMode && !values?.cover) {
            bodyFormData.append("cover", "");
          }
        }
        const response = await PostFunction({
          data: bodyFormData,
          Route: editMode
            ? `${UrlApi.media_gallery.edit}/${paramID}`
            : UrlApi.media_gallery.add,
          showalert: true,
          state: getState,
          isMultipart: true,
          dispatch: dispatch,
          usersRoute: true,
        });
        dispatch(setLoading(false));
        callback(response);
      } catch (err) {
        console.error(err);
        dispatch(setLoading(false));
        callback(false);
      }
    };
